import React, { Component } from 'react'
import PropTypes from 'prop-types'

class AlertMessage extends Component {
  render() {
    if( !this.props.display ) {
      return (null);
    }
	let className = 'alert alert-' + this.props.type;
	if (this.props.additionalCssClass) {
		className += ' ' + this.props.additionalCssClass;
	}
    return (
      <div className={className} role="alert">
        {this.props.children}
      </div>
    );
  }
}
AlertMessage.defaultProps = {
  // Be careful with the default display. Passing in an undefined value will use the default of 'true'
  display: true,
  children: <strong>You've confirmed that the information is correct. If you need to update the information, please call us at 800-522-4762.</strong>,
  type: 'warning',
  additionalCssClass: ''
}

AlertMessage.propTypes = {
   display: PropTypes.bool,
   children: PropTypes.node.isRequired,
   type: PropTypes.oneOf(['success', 'info', 'warning', 'danger']),
   additionalCssClass: PropTypes.string
};

export default AlertMessage;